import { gql } from '__generated__';

export default gql(`
  mutation AddScanner($input: AddScannerInput!) {
    addScanner(input: $input) {
      id
    }
  }
`);
